var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBCabinetDepositPeriodIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 7.2002C14.914 6.9438 14.814 6.69479 14.7 6.45319M13.725 4.9526C13.5346 4.7314 13.3314 4.5244 13.1154 4.3316M10.8 3.0002C11.0671 3.08704 11.3285 3.19085 11.5824 3.311",
    stroke: "#FF592E",
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.0002 7.9498C8.79252 7.9498 8.58952 8.01139 8.41685 8.12676C8.24417 8.24214 8.10959 8.40612 8.03012 8.59799C7.95065 8.78985 7.92986 9.00097 7.97037 9.20465C8.01088 9.40833 8.11089 9.59542 8.25773 9.74227C8.40458 9.88911 8.59167 9.98911 8.79535 10.0296C8.99903 10.0701 9.21015 10.0493 9.40201 9.96988C9.59388 9.89041 9.75786 9.75582 9.87324 9.58315C9.98861 9.41048 10.0502 9.20747 10.0502 8.9998M9.0002 7.9498C9.27867 7.9498 9.54574 8.06043 9.74266 8.25734C9.93957 8.45426 10.0502 8.72133 10.0502 8.9998M9.0002 7.9498V6.1998M10.0502 8.9998H13.2002",
    stroke: "#FF592E",
    strokeWidth: 1.1,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 3C5.6862 3 3 5.6862 3 9C3 12.3138 5.6862 15 9 15C12.3138 15 15 12.3138 15 9",
    stroke: "#FF592E",
    strokeWidth: 1.1,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBCabinetDepositPeriodIcon);
export default __webpack_public_path__ + "static/media/b_cabinet_deposit_period_icon.e21d01ebea8ff820f4885a581d5057a9.svg";
export { ForwardRef as ReactComponent };